import { render } from "./Divider.vue?vue&type=template&id=8130476a"
const script = {}

import "./Divider.vue?vue&type=style&index=0&id=8130476a&lang=css"

import exportComponent from "/Users/ilvinipitter/code/lider-fornecedores/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__